import createFiltersStore from '@/stores/createFiltersStore'
import { DEFAULT_SUSTAINABILITY_FILTERING } from '@/utils/constants'

export const useSustainabilityFiltersStore = createFiltersStore(
    'activeSustainabilityFilters',
    DEFAULT_SUSTAINABILITY_FILTERING
)
